import { apiV1 } from './api';

const duplicateCheck = (entityType, params) =>
  apiV1.post(`/duplicate_check/${entityType}`, { parameters: params });

export { duplicateCheck };
